import React from "react";
import { useDraggable } from "@dnd-kit/core";
import JobKanbanCard, { JobKanbanCardProps } from "./JobKanbanCard";

type Props = Omit<JobKanbanCardProps, "innerRef" | "dragAttributes" | "dragListeners" | "isDragging"> & {
  cardId: string;
  laneId: string;
};

/**
 * Pointer-based drag wiring for a job card.
 *
 * The card itself stays presentational — this wrapper is the only place that
 * knows about dnd-kit, so the same component can be rendered inside a
 * <DragOverlay> without becoming draggable a second time.
 */
export default function DraggableJobCard({ cardId, laneId, ...cardProps }: Props) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: cardId,
    data: { laneId },
  });

  return (
    <JobKanbanCard
      {...cardProps}
      innerRef={setNodeRef}
      dragAttributes={attributes}
      dragListeners={listeners}
      isDragging={isDragging}
      // The original card stays in place as a muted placeholder while the
      // overlay follows the pointer.
      style={isDragging ? { opacity: 0.4 } : undefined}
    />
  );
}
